<section class="worklist-item-wrapper">
  <section *ngFor="let parsedValue of valuesParsed;let i = index;trackBy: trackByFn"
           class="level-{{i}} worklist-item {{parsedValue.automationClassName}}"
           [ngClass]="{main:isMainValue(parsedValue,i),sub:!isMainValue(parsedValue,i),columnValueHide:shouldHideValue(parsedValue)}"
           [ngSwitch]="parsedValue.type">
    <div *ngSwitchCase="'actions'">
      <gen-worklist-actions
        *ngIf="showActions$ | async"
        [type]="type"
        [currentUserId]="currentUserId"
        [practitionerType]="practitionerType"
        [rowData]="value"
        [trackByField]="trackByField"
        [injectedActions]="injectedActions"
        [worklistActions]="worklistActions"
        [disabledworklistActions]="disabledworklistActions"
        [mode]="mode"
        class="{{parsedValue.className}}"
      ></gen-worklist-actions>
    </div>
    <!-- note -->
    <div *ngSwitchCase="'note'"  class="notes" [ngClass]="{'hasNotes':value.hasNotes}">
      <gen-aberration-comments
        *ngIf="(!value.cantEditNotes)"
        (click)="$event.stopPropagation()"
        (noteAddedEmit)="value.hasNotes = $event"
        (noteCompletedEmit)="noteCompleted($event)"
        [aberration]="value"
        [searchTerm]="parsedValue.payloadData.contextQuery"
        [queryType]="parsedValue.payloadData.queryType"
        [nonAberation]="parsedValue.payloadData.nonAberation"
        [referenceTypes]="parsedValue.payloadData.contextPaths"
        [titleConfig]="parsedValue.payloadData.titleConfig"
        [maxTooltipHeight] = "noteTooltipMaxHeight"
        [maxTooltipWidth] = "noteTooltipMaxWidth"
        [directData] = "parsedValue.payloadData.directData"
        [revisionPath] = "parsedValue.payloadData.revisionPath"
        [notes] = "parsedValue.payloadData.notes"
        [activity] = "parsedValue.payloadData.activity"
        [currentUserId] = "currentUserId"
         ></gen-aberration-comments>
    </div>
    <!-- notes -->
    <div *ngSwitchCase="'notes'">
      <div class="notes" [ngClass]="{'hasNotes':value.note}">
        <i class="icon__notifications"  (click)="openNotePopup($event, value.note,parsedValue)"></i>
      </div>
    </div>
    <!-- date -->
    <span *ngSwitchCase="'date'" class="date {{parsedValue.payload}} {{parsedValue?.payloadData?.className}}"
          [innerHtml]="parsedValue.value|date:'dd MMM y'| multiHighlight:searchText"></span>
    <!-- datetime -->
    <span *ngSwitchCase="'datetime'" class="date {{parsedValue.payload}} {{parsedValue?.payloadData?.className}}"
          [innerHtml]="parsedValue.value|date:'dd MMM y hh:mm:ss'| multiHighlight:searchText"></span>
    <!-- boolean-indication -->
    <ng-container *ngSwitchCase="'boolean-indication'">
      <div *ngIf="!isCustomBooleanIndication(parsedValue)">
        <p-checkbox  class="boolean-indication {{parsedValue.payload}} {{parsedValue?.payloadData?.className}} {{parsedValue?.payloadValue?.class}}"
                    [(ngModel)]="parsedValue.originValue" [binary]="true" [disabled]="true"></p-checkbox>
      </div>
      <span *ngIf="isCustomBooleanIndication(parsedValue)"
            class="{{getCustomBooleanIndicationClass(parsedValue)}}"></span>
    </ng-container>
    <!-- priority -->
    <div *ngSwitchCase="'priority'" class="priority {{parsedValue.className}}">
      <span class="icon__circle priority-icon priority-{{(parsedValue.className.trim()) | lowercase}}"></span>
      <span [innerHTML]="parsedValue.value| multiHighlight:searchText|translate"></span>
    </div>
    <!-- arrayContent -->
    <div *ngSwitchCase="'arrayContent'" class="arrayContent {{parsedValue.className}}">
      <div genTooltip [tooltipHtml]="parsedValue.payloadData.htmlContent" [tooltipPosition]="'LEFT'"
           [appendToBody]="'true'" [tooltipShow]="true">{{parsedValue.payloadData.title}}</div>
    </div>
    <!-- arrayContentOrgList -->
    <div *ngSwitchCase="'arrayContentOrgList'" class="arrayContentOrgList {{parsedValue.className}}">
      <div genTooltip [tooltipHtml]="parsedValue.payloadData.htmlContent" [tooltipPosition]="'LEFT'"
           [appendToBody]="'true'" [tooltipShow]="true">{{parsedValue.payloadData.title}}</div>
    </div>
    <!-- arrayContentIcon -->
    <div *ngSwitchCase="'arrayContentIcon'" class="arrayContentIcon {{parsedValue.className}}">
      <div class="table-column-mrn">
        <span *ngIf="this.showMultiTooltip" genTooltip [tooltipHtml]="parsedValue.payloadData.htmlContentIcon" [tooltipPosition]="'BOTTOM'"
              [appendToBody]="'true'" [tooltipShow]="true"><img style="height: 1rem; margin-bottom: 0.17rem; margin-right: 0.14rem;" src="assets/ispm/icons/Info_Icon.png"></span>
        <span class="arrayContentIcon {{parsedValue?.payloadData?.cssClass}}" [innerHTML]="parsedValue.payloadData.title|highlight:searchText"></span>
      </div>
    </div>
    <!-- age -->
    <div *ngSwitchCase="'age'" class="age  {{parsedValue?.payloadData?.className}}">
      <div >{{parsedValue?.payloadData?.value}}</div>
    </div>
    <!-- tag -->
    <span *ngSwitchCase="'tag'" class="tag {{parsedValue.className}} {{parsedValue.value|lowercase}}"
          [innerHTML]="parsedValue.value| multiHighlight:searchText"></span>
    <!-- qmsalert -->
    <span *ngSwitchCase="'qmsalert'" class="tag {{parsedValue.className}} issue"
          [ngClass]="{'deactivate-alerts':!(getValueByKey('nc_alerts_qty',0)  > 0)}">
      Issue
    </span>
    <!-- icon -->
    <div *ngSwitchCase="'icon'">
      <span class="{{(parsedValue.value)}}"></span>
    </div>
    <!-- array -->
    <ng-container *ngSwitchCase="'array'">
      <div *ngFor="let singleValue of parsedValue.value; trackBy: trackByFn" [ngClass]="singleValue?.className">
        <span [innerHTML]="escapeTag(singleValue.value)|highlight:searchText"></span>
      </div>
    </ng-container>
    <!-- iconWithData -->
    <ng-container *ngSwitchCase="'iconWithData'">
        <span class="worklist__icon__{{parsedValue.value || parsedValue.payload | lowercase}}" [innerHTML]="(parsedValue.value || parsedValue.payload)| multiHighlight:searchText"></span>
    </ng-container>
    <!-- text -->
    <span *ngSwitchDefault class="text {{parsedValue.className}} {{(parsedValue.payloadData) ? (parsedValue.payloadData.className) : ''}}"
          [hidden]="parsedValue.value==null && parsedValue.payload == null"
          [innerHTML]="escapeChevron((parsedValue.value || parsedValue.payload))| multiHighlight:searchText"></span>
    <!-- execute -->
    <div *ngSwitchCase="'execute'" class="execute">
      <ispm-worklist-execute
        [currentUserId]="currentUserId"
        [practitionerType]="practitionerType"
        [rowData]="value"
        [payload]="parsedValue.payloadValue"
        [executeActions]="parsedValue.executeActions"
      ></ispm-worklist-execute>
    </div>
    <!-- textWithEllipsis -->
    <span *ngSwitchCase="'textWithEllipsis'"
          class="text {{parsedValue.className}} {{(parsedValue.payloadData) ? (parsedValue.payloadData.className) : ''}}"
          [hidden]="parsedValue.value==null && parsedValue.payload == null"
          [innerHTML]="getTextValue(parsedValue)| multiHighlight:searchText"
          genTooltip [tooltipPosition]="'BOTTOM'"
          [tooltipText]="escapeChevron((parsedValue.value || parsedValue.payload))"
          [tooltipShow]="getTextTooltipDisplayStatus(parsedValue)"
          [maxTooltipWidth]="parsedValue.payloadValue.tooltipMaxWidth || 400"
          [fontsize]="parsedValue.payloadValue.tooltipFontSize || 'medium'"
    ></span>
  </section>
</section>
